import {
    type ViewStyle,
    StyleSheet
} from "react-native";
import type {
    Mutable
} from "../../../../types";

const stylesheet = StyleSheet.create({
    presenceItem: {
        flexDirection: "row",
        maxWidth: "100%"
    },
    wrap: {
        flexDirection: "row",
        flexWrap: "wrap"
    },
    scroll: {
        flexDirection: "row",
        flexGrow: 0
    },
    scrollContent: {
        alignItems: "center",
        flexDirection: "row"
    }
});

export const useStyles = ({
    spaces
}: {
    spaces: NCoreUIKit.ActivePalette["spaces"];
}) => {
    const styles = {
        content: {
            gap: spaces.spacingSm
        } as Mutable<ViewStyle>
    };

    return styles;
};
export default stylesheet;
